export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    big_win: [
      0,
      5077.913832199546,
    ],
    button_spin: [
      7000,
      439.7278911564628,
    ],
    end_free_spin: [
      9000,
      3940.136054421769,
    ],
    free_bet_big_win: [
      14000,
      1377.2335600907031,
    ],
    free_bet_mega_win: [
      17000,
      2213.151927437643,
    ],
    free_bet_total_win: [
      21000,
      979.591836734695,
    ],
    free_bet_ultra_win: [
      23000,
      1319.1836734693893,
    ],
    free_spin_ambient: [
      26000,
      43321.179138322,
    ],
    free_spin_music: [
      71000,
      35086.80272108843,
    ],
    free_spin_popup: [
      108000,
      4572.879818594103,
    ],
    free_spin_start: [
      114000,
      4279.727891156469,
    ],
    inside_buttons: [
      120000,
      193.01587301586665,
    ],
    main_ambient: [
      122000,
      93865.21541950114,
    ],
    main_music: [
      217000,
      146951.83673469388,
    ],
    mega_win: [
      365000,
      6192.471655328802,
    ],
    outside_buttons: [
      373000,
      149.47845804988447,
    ],
    reel_spin: [
      375000,
      1057.9591836734608,
    ],
    reel_stop_01: [
      378000,
      187.21088435376032,
    ],
    reel_stop_02: [
      380000,
      227.8458049886467,
    ],
    reel_stop_03: [
      382000,
      280.0907029478594,
    ],
    reel_stop_04: [
      384000,
      204.62585034010772,
    ],
    reel_stop_05: [
      386000,
      253.96825396825307,
    ],
    regular_win: [
      388000,
      3287.074829931953,
    ],
    scatter_win: [
      393000,
      3870.476190476211,
    ],
    tap_to_play: [
      398000,
      2596.281179138316,
    ],
    ultra_win: [
      402000,
      5475.555555555558,
    ],
    wild_win: [
      409000,
      3644.0816326530694,
    ],
  },
}
